import app from "../_app";

const productImagesPopup = document.querySelector('.js-product-images-popup');

if(productImagesPopup) {
    const triggers = [...document.querySelectorAll('.js-product-images-popup-trigger')];
    const thumbnails = [...productImagesPopup.querySelectorAll('.js-product-images-popup-thumbnail')];

    const triggerClickHandler = (e) => {
        const trigger = e.currentTarget;

        if(trigger.hasAttribute('data-index')) {
            app.lockBody();
            const thumbnail = thumbnails.find((t) => +t?.dataset?.index === +trigger.dataset.index);

            productImagesPopup.setAttribute('data-open', '');
            thumbnail.dispatchEvent(new Event('click'));
        } else {
            productImagesPopup.removeAttribute('data-open');
            app.unlockBody();
        }
    };

    triggers.map(trigger => trigger.addEventListener('click', triggerClickHandler))
}
